<!-- <button class="btn btn-primary btn-sm" (click)="openScheduleModal($event)"></button> -->

<hr>

<div class="container-scheduler">
    <div class="left-div" style="max-width:600px">
        <div class="scheduler-container">
            <div class="scheduler-timezone-info">
                <ng-container *ngIf="companyTimezone$ | async as companyTimezone">
                    <fieldset style="width:max-content">
                        <legend>Timezone configuration</legend>
                        <label class="form-label">Configured timezone</label>
                        <dx-text-box [width]="200" [disabled]="true" [value]="companyTimezone">
                        </dx-text-box>
                        <label class="form-label">Current date in timezone</label>
                        <dx-text-box [width]="200" [disabled]="true" [value]="getCurrentTimeZoneStringWithCompanyTimezone()">
                        </dx-text-box>
                        <br>
                    </fieldset>
                </ng-container>
            </div>
            <div class="scheduler-general-info">
                <ng-container *ngIf="listOfNextExecutionDate$ | async as executionDateList">
                    <ng-container *ngIf="executionDateList.length > 0">
                        <fieldset style="width:max-content">
                            <legend>Schedule information</legend>
                            <label class="form-label">Next execution date (for configured timezone)</label>
                            <dx-list [dataSource]="executionDateList" [height]="80" [width]="300">
                                <div *dxTemplate="let item of 'item'">
                                    {{TransformDateToTimezone(item)}}
                                </div>
                            </dx-list>
                            <br>
                        </fieldset>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <div *ngIf="companyTimezone$ | async">
            <fieldset style="max-width:588px">
                <legend>Scheduler configuration</legend>
                <div class="row" style="margin-bottom: 0px">
                    <div class="form-group">

                        <div class="settings-container">
                            <div class="setting-description">
                                <label class="form-label">Enable scheduler</label>
                            </div>
                            <div class="setting-field">
                                <dx-switch class="al-switch" [(value)]="isSchedulerEnabled"></dx-switch>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isSchedulerEnabled">
                    <al-link-edit-scheduler-form [linkSchedulerInformation]="linkSchedulerInformation" [hourlySchedulerAllowanceHours]="usableLink.hourlySchedulerAllowanceHours">
                    </al-link-edit-scheduler-form>
                </div>
                <div style="padding-bottom: 13px">
                    <button (click)="saveSchedulerConfiguration()" type="button" class="btn btn-sm add-login-button btn-primary">Save</button>
                </div>
            </fieldset>
        </div>
    </div>

    <div class="right-div">
        <div *ngIf="companyTimezone$ | async as companyTimezone">
            <fieldset>
                <legend>Calender</legend>
                <div class="settings-container" style="padding-bottom: 10px;">
                    <div class="setting-description">
                        <label class="form-label">Show schedules for all links</label>
                    </div>
                    <div class="setting-field">
                        <dx-switch class="al-switch" [(value)]="userConfig.showAllLinkSchedules" (onValueChanged)="gridDisplayAllSwitchValueChanged($event)"></dx-switch>
                    </div>
                </div>
                <dx-scheduler [showCurrentTimeIndicator]="true" [shadeUntilCurrentTime]="true" (onAppointmentRendered)="onAppointmentRendered($event)" [timeZone]="companyTimezone" [dataSource]="appointments" [views]="['day', 'week', 'month']" currentView="month" (onCellClick)="onAppointmentClick($event)"
                    (onAppointmentDblClick)="onAppointmentClick($event)" [currentDate]="currentDate" [height]="578">
                </dx-scheduler>

                <br>
            </fieldset>
        </div>
    </div>
</div>
